<template>
    <section class="bg-[#F5F5F5] py-20 sm:py-28">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mb-14">
                <span class="text-xs font-semibold uppercase tracking-widest text-[#A07830]">Why Nobel Academy</span>
                <h2 class="mt-3 text-3xl sm:text-4xl font-extrabold text-[#17364a] tracking-tight">
                    Best Online<br />Learning Experience
                </h2>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                <div
                    v-for="feature in features"
                    :key="feature.name"
                    class="group bg-white p-8 border border-[#E5E5E5] hover:border-[#A07830] transition-colors duration-200"
                >
                    <div class="mb-5 flex h-12 w-12 items-center justify-center bg-[#F5F5F5] group-hover:bg-[#A07830]/10 transition-colors">
                        <img v-if="feature.icon" :src="feature.icon" alt="" class="h-6 w-6 object-contain" />
                    </div>
                    <h3 class="text-base font-bold text-[#17364a] mb-2">{{ feature.name }}</h3>
                    <p class="text-sm text-gray-500 leading-relaxed">{{ feature.description }}</p>
                    <!-- Gold bottom line on hover -->
                    <div class="mt-6 h-px w-0 bg-[#A07830] group-hover:w-full transition-all duration-300"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const features = [
    {
        name: 'Expert Tutors',
        description: 'Our tutors are highly qualified professionals with proven expertise in their fields.',
        icon: 'images/icons/features/arabic.png',
    },
    {
        name: 'Flexible Scheduling',
        description: 'Choose your own schedule and learn at your own pace.',
        icon: 'images/icons/features/calendar.png',
    },
    {
        name: 'Interactive Learning',
        description: 'Engaging lessons with interactive tools and resources.',
        icon: 'images/icons/features/chat.png',
    },
    {
        name: 'Certified Instructors',
        description: 'All instructors are certified professionals with verified credentials.',
        icon: 'images/icons/features/certified.png',
    },
    {
        name: 'Comprehensive Curriculum',
        description: 'A well-structured curriculum covering all aspects of your chosen subject.',
        icon: 'images/icons/features/zip.png',
    },
    {
        name: '24/7 Support',
        description: 'Our support team is available around the clock to assist you.',
        icon: 'images/icons/features/support.png',
    },
]
</script>
